import URL from '../helpers/URL';
import Cookie from '../helpers/Cookie';

;$(function() {

	function cityAsked(id) {
		Cookie.set('city_ask', '1', {
			expires: 7*24*60*60
		});
		Cookie.set('city', id, {
			expires: 7*24*60*60
		});

		$('.city-ask').remove();
	}

	function checkForProductPage(url) {
		let route = URL.full.split('/').slice(3);

		if (route.reverse()[0] == '')
			route = route.slice(1);

		route.reverse();

		if (route.length == 4 && ['cars', 'moto', 'commercial'].indexOf(route[0]) > -1) {
			route.unshift(url);
			return '/' + route.join('/') + '/';
		}

		if (route.length == 5 && ['cars', 'moto', 'commercial'].indexOf(route[1]) > -1) {
			if (url == '')
				route = route.slice(1);
			else
				route[0] = url;

			return '/' + route.join('/') + '/';
		}

		return false;
	}

	$('.city-ask__yes').click(function() {
		let url = $(this).data('url');

		cityAsked($(this).data('id'));

		let newUrl = checkForProductPage(url);

		if (newUrl) url = newUrl;
		else url = '/' + (url == '' ? '' : url + '/');

		window.location.href = url;
	});

	$('.city-ask__no').click(function() {
		cityAsked(0);

		window.location.href = '/all/';
	});

});